var map = {
	"./basketball-active.webp": 1462,
	"./basketball.webp": 1463,
	"./bg.webp": 1464,
	"./football-active.webp": 1465,
	"./football.webp": 1466,
	"./games-active.webp": 1467,
	"./games.webp": 1468,
	"./information.webp": 1469,
	"./live-streaming-cover.webp": 1470,
	"./lv-active-bg.webp": 1471,
	"./video-bg.webp": 1472,
	"./video-icon.webp": 1473,
	"./vs.webp": 1474
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 466;